export const MAX_COUNT = 10;
export const ErrorResponseMessage =
  "Something went wrong. Please try again later.";
export const UnAuthorized = "Login in again";
export const NotApplicableMessage = "“This Screen is not applicable for Business Offer”"
